// extracted by mini-css-extract-plugin
export var footer = "_lo-5";
export var fulfillmentInput = "_lo-0";
export var shipDateInput = "_lo-1";
export var shipmentModal = "_lo-2";
export var shipmentModalContent = "_lo-3";
export var tableContainer = "_lo-4";